import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async estadoImpersonacion() {
    const response = await api.post(API_URL + "impersonation/get", null);
    return response.data;
  },

  async setRolTemporal(payload) {
    const response = await api.post(API_URL + "impersonation/set", payload);
    return response.data;
  },

  async clearRolTemporal() {
    const response = await api.post(API_URL + "impersonation/clear", null);
    return response.data;
  },
};
